module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/dinner-bcff4fa5c8f514cf3aaf9bc6377d78af.svg";